export default __webpack_public_path__ + "static/media/Mobile_notification_SVG.3b76329f.svg";